// S&P 500 stocks organized by sector - shared utility
export const SP500_BY_SECTOR = {
  "Information Technology": {
    color: "#3B82F6",
    stocks: ["AAPL", "MSFT", "NVDA", "AVGO", "CSCO", "ADBE", "CRM", "INTC", "AMD", "TXN", "QCOM", "AMAT", "LRCX", "ADI", "KLAC", "SNPS", "CDNS", "NXPI", "APH", "MCHP", "TEL", "FTNT", "KEYS", "ON", "MPWR", "ANSS", "SWKS", "AKAM", "GEN", "FFIV", "JNPR", "QRVO"]
  },
  "Health Care": {
    color: "#10B981",
    stocks: ["UNH", "JNJ", "LLY", "PFE", "MRK", "ABBV", "TMO", "ABT", "DHR", "BMY", "AMGN", "GILD", "VRTX", "ISRG", "REGN", "CI", "CVS", "ELV", "HUM", "MCK", "SYK", "BDX", "ZTS", "BSX", "MDT", "EW", "DXCM", "IDXX", "A", "IQV", "MTD", "HOLX", "ALGN", "COO", "LH", "DGX", "CRL", "PKI", "RVTY", "BAX", "TECH", "BIO", "HSIC", "XRAY"]
  },
  "Financials": {
    color: "#F59E0B",
    stocks: ["JPM", "V", "MA", "BAC", "WFC", "GS", "MS", "BLK", "AXP", "SCHW", "C", "CB", "PGR", "MMC", "AON", "CME", "ICE", "MCO", "SPGI", "TRV", "AIG", "MET", "PRU", "ALL", "AFL", "HIG", "ACGL", "WTW", "RJF", "STT", "BK", "NTRS", "FITB", "MTB", "PNC", "USB", "CFG", "RF", "HBAN", "KEY", "CINF", "CMA", "ZION", "L", "GL", "AIZ", "BEN", "IVZ", "TROW", "AMP", "BRO"]
  },
  "Consumer Discretionary": {
    color: "#EC4899",
    stocks: ["AMZN", "TSLA", "HD", "MCD", "NKE", "LOW", "TJX", "SBUX", "BKNG", "CMG", "MAR", "ORLY", "AZO", "ROST", "DHI", "LEN", "GM", "F", "YUM", "DPZ", "HLT", "POOL", "ULTA", "BBY", "DRI", "LVS", "WYNN", "CZR", "MGM", "CCL", "RCL", "NCLH", "TPR", "RL", "VFC", "ETSY", "EBAY", "APTV", "BWA", "LKQ", "GRMN", "GPC", "AAP"]
  },
  "Communication Services": {
    color: "#8B5CF6",
    stocks: ["GOOGL", "GOOG", "META", "NFLX", "DIS", "CMCSA", "VZ", "T", "TMUS", "CHTR", "EA", "TTWO", "WBD", "OMC", "IPG", "FOXA", "FOX", "PARA", "NWS", "NWSA", "MTCH", "LYV"]
  },
  "Industrials": {
    color: "#6366F1",
    stocks: ["GE", "CAT", "BA", "HON", "UNP", "RTX", "DE", "LMT", "UPS", "NOC", "GD", "FDX", "CSX", "NSC", "WM", "EMR", "ETN", "ITW", "PH", "ROK", "CMI", "PCAR", "FAST", "ODFL", "CARR", "OTIS", "JCI", "TT", "AME", "GWW", "DOV", "IR", "CPRT", "WAB", "CTAS", "VRSK", "LII", "PWR", "XYL", "URI", "JBHT", "DAL", "UAL", "LUV", "AAL", "AXON", "TDG", "SNA", "TXT", "HII", "LDOS", "J", "BR", "EXPD", "CHRW", "AOS", "ALLE", "GNRC", "RHI", "MAS", "PNR", "NDSN", "SWK", "IEX"]
  },
  "Consumer Staples": {
    color: "#14B8A6",
    stocks: ["PG", "KO", "PEP", "COST", "WMT", "PM", "MO", "MDLZ", "CL", "KMB", "GIS", "SYY", "KR", "STZ", "ADM", "HSY", "K", "CAG", "MKC", "CLX", "HRL", "SJM", "CPB", "CHD", "TSN", "TAP", "BG", "KDP", "EL", "MNST"]
  },
  "Energy": {
    color: "#EF4444",
    stocks: ["XOM", "CVX", "COP", "SLB", "EOG", "PXD", "MPC", "VLO", "PSX", "OXY", "KMI", "WMB", "HAL", "HES", "DVN", "FANG", "BKR", "TRGP", "OKE", "EQT", "APA", "MRO"]
  },
  "Utilities": {
    color: "#A855F7",
    stocks: ["NEE", "DUK", "SO", "D", "AEP", "EXC", "SRE", "XEL", "PEG", "ED", "WEC", "ES", "AWK", "DTE", "ETR", "FE", "PPL", "AES", "CNP", "CMS", "NI", "EVRG", "ATO", "LNT", "NRG", "PNW"]
  },
  "Real Estate": {
    color: "#0EA5E9",
    stocks: ["PLD", "AMT", "EQIX", "CCI", "PSA", "SPG", "O", "WELL", "DLR", "VICI", "AVB", "EQR", "EXR", "SBAC", "ARE", "MAA", "VTR", "INVH", "IRM", "UDR", "CPT", "KIM", "REG", "BXP", "FRT", "HST", "PEAK"]
  },
  "Materials": {
    color: "#84CC16",
    stocks: ["LIN", "APD", "SHW", "FCX", "NEM", "NUE", "ECL", "DD", "DOW", "PPG", "VMC", "MLM", "ALB", "CTVA", "CF", "MOS", "IFF", "CE", "EMN", "AVY", "IP", "PKG", "WRK", "SEE", "BALL", "AMCR", "FMC"]
  }
};

/**
 * Find which sector a stock belongs to
 * @param {string} symbol - Stock symbol
 * @returns {{ sector: string, color: string } | null}
 */
export const findStockSector = (symbol) => {
  const upperSymbol = symbol.toUpperCase();
  for (const [sector, data] of Object.entries(SP500_BY_SECTOR)) {
    if (data.stocks.includes(upperSymbol)) {
      return { sector, color: data.color };
    }
  }
  return null;
};

/**
 * Get related stocks from the same sector
 * @param {string} symbol - Current stock symbol
 * @param {number} limit - Max number of related stocks to return
 * @returns {Array<{ symbol: string, sector: string, color: string }>}
 */
export const getRelatedStocks = (symbol, limit = 8) => {
  const upperSymbol = symbol.toUpperCase();
  const sectorInfo = findStockSector(upperSymbol);
  
  if (!sectorInfo) return [];
  
  const sectorStocks = SP500_BY_SECTOR[sectorInfo.sector].stocks;
  
  // Filter out current stock and randomize selection
  const otherStocks = sectorStocks.filter(s => s !== upperSymbol);
  
  // Shuffle and take first N stocks
  const shuffled = otherStocks.sort(() => Math.random() - 0.5);
  
  return shuffled.slice(0, limit).map(s => ({
    symbol: s,
    sector: sectorInfo.sector,
    color: sectorInfo.color
  }));
};
